module.exports = __webpack_public_path__ + "img/why-1.d37e6f95.png";